/* eslint-disable import/prefer-default-export */

export const maxFileSize = 2097152;
